// extracted by mini-css-extract-plugin
export default {"title":"XTPZR","accordion":"yhbsU","skeleton-progress":"mjo4e"};